import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'
import { MdEdit, MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { CHECKLIST_STATUS } from '~/types/checklist'

import { ChecklistStatusBadge } from '~/components/Badges'
import Button from '~/components/Buttons/Button'
import Team from '~/components/Team'
import Tooltip from '~/components/Tooltip'
import UserCard from '~/components/UserCard'
import { MILLISECONDS_IN_NANO } from '~/const'

import './styles.scss'

type DateCardInfo = {
  date: number
  name: string
  picture?: string
}

type UserCardInfo = {
  job?: string
  name: string
  picture?: string
}

interface Props {
  changelog?: string
  createdBy?: DateCardInfo
  onEditTodo: VoidFunction
  releaseDate?: string
  status: CHECKLIST_STATUS
  team: UserCardInfo[]
  title: string
  updatedBy?: DateCardInfo
  version?: string
}

const TodoDetailsGeneralInformation = ({
  changelog,
  createdBy,
  onEditTodo,
  releaseDate,
  status,
  team,
  title,
  updatedBy,
  version,
}: Props): ReactElement => {
  return (
    <div className="checklist-details-general-information-container">
      <div className="flex-row-container">
        <div className="title-container">
          <div className="title-container__title">{title}</div>
          <ChecklistStatusBadge value={status} />
        </div>
        <Button className="edit-button" onClick={onEditTodo} outlined size="small">
          <MdEdit color="#ff5301" size={14} />
          Edit
        </Button>
      </div>
      <div className="flex-row-container align-end space-between">
        {version || releaseDate || changelog ? (
          <div className="column">
            {version && (
              <div className="text-content">
                Link to version <span className="text-content__value">{version}</span>
              </div>
            )}
            {releaseDate && (
              <div className="text-content">
                Release date <span className="text-content__value">{formatDate(releaseDate)}</span>
              </div>
            )}
            {changelog && (
              <Tooltip
                align={{ points: ['tl', 'bl'] }}
                mouseEnterDelay={0.3}
                overlay={<div className="changelog-tooltip">{changelog}</div>}
                placement="bottomRight"
                trigger={['hover']}
              >
                <div className="changelog">
                  See changelog <MdInfoOutline size={16} />
                </div>
              </Tooltip>
            )}
          </div>
        ) : null}
        <div className="column">
          <Team label="Team" size="small" users={team} />
        </div>
        <div className="column">
          {createdBy ? (
            <UserCard
              label="Created by"
              name={createdBy.name}
              picture={createdBy.picture}
              size="small"
              subInfo={formatDate(createdBy.date / MILLISECONDS_IN_NANO, DATE_FORMATS.DEFAULT_WITH_HOURS)}
            />
          ) : null}
        </div>
        <div className="column">
          {updatedBy ? (
            <UserCard
              label="Last update by"
              name={updatedBy.name}
              picture={updatedBy.picture}
              size="small"
              subInfo={formatDate(updatedBy.date / MILLISECONDS_IN_NANO, DATE_FORMATS.DEFAULT_WITH_HOURS)}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default TodoDetailsGeneralInformation
